import { Module, Store } from 'vuex'
import { FieldValue } from '@/types/form.types'

export const NAME_SPACE = 'form'
const namespace = (fragment: string) => `${NAME_SPACE}/${fragment}`

type Form = Record<string, FieldValue>

export type State = Record<string, Form>

export type FormStore = Store<{ [NAME_SPACE]: State }>

export const createForm = (store: FormStore, name: string, model: Form): void => {
  store.commit(namespace('createForm'), { name, model })
}
export const createFieldGetter = (store: FormStore, formName: string, field: string) => (): FieldValue => store.getters[namespace('getField')][formName][field]
export const resetForm = (store: FormStore, name: string): Promise<void> => store.dispatch(namespace('resetForm'), name)

const formStore: Module<State, {}> = {
  namespaced: true,
  state: {},
  mutations: {
    createForm: (
      state: State,
      { name, model }: { name: string; model: Form }
    ) => {
      if (!state[name]) { state[name] = model }
    },
    deleteForm: (state: State, name: keyof State) => { delete state[name] },
    setField: (
      state: State,
      { form, field, value }: { form: string; field: string; value: FieldValue }
    ) => {
      state[form][field] = value
    }
  },
  getters: {
    getField: (state: State) => state
  },
  actions: {
    resetForm: ({ commit }, form: keyof State) => {
      commit('deleteForm', form)
    }
  }
}

export default formStore
